/* Botón «Añadir al carrito» animado (cajitas y camión) - Salas García Ópticos.
   Se monta ENCIMA del botón del tema: la compra la sigue haciendo product-form.js.
   Este archivo solo (1) añade al botón sus capas (fondos, cajitas, camión), (2) lanza la animación al pulsar,
   (3) retiene la apertura del carrito lateral hasta que termina el movimiento y
   (4) cancela el efecto si la compra falla. */
(function () {
  'use strict';

  var RUN = 2400; /* ms: igual que --cm-run en cart-morph.css */
  var HOLD = 520; /* ms que el botón conserva su «Añadido» mientras se abre el carrito */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var active = null; /* animación en curso */
  var gate = null; /* promesa que retiene la apertura del carrito */
  var hold = null; /* { timer, host } del «Añadido» que se mantiene un instante */
  var subscribed = false;
  var live = null;

  var CART = '<span class="cm-cart" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg></span>';
  var OK = '<span class="cm-ok" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><circle cx="12" cy="12" r="10"/><path d="M8 12.5l2.7 2.7L16 9.6"/></svg><span>Añadido</span></span>';
  var TRUCK = '<span class="cm-truck" aria-hidden="true"><span class="cm-lines"><i></i><i></i><i></i></span>' +
    '<svg viewBox="0 0 64 40" focusable="false">' +
    '<ellipse cx="32" cy="38.5" rx="26" ry="1.8" fill="#000" fill-opacity=".12"/>' +
    '<rect x="2" y="5" width="37" height="24" rx="4" fill="#2e7d57"/>' +
    '<rect x="8" y="11" width="25" height="3" rx="1.5" fill="#fff" fill-opacity=".85"/>' +
    '<rect x="8" y="17" width="16" height="3" rx="1.5" fill="#fff" fill-opacity=".85"/>' +
    '<path d="M41 11.5h11.2a3 3 0 0 1 2.4 1.2l6 8.2a3 3 0 0 1 .6 1.8V29H41z" fill="#27704d"/>' +
    '<path d="M45 15h7l4.4 6.2H45z" fill="#e8f3ed"/>' +
    '<rect x="2" y="28" width="59" height="4" rx="2" fill="#2b2b2e"/>' +
    '<circle cx="14" cy="32" r="5.5" fill="#1d1d1f"/><circle cx="14" cy="32" r="2" fill="#e8f3ed"/>' +
    '<circle cx="50" cy="32" r="5.5" fill="#1d1d1f"/><circle cx="50" cy="32" r="2" fill="#e8f3ed"/>' +
    '</svg></span>';
  var BOXES = [['-4px', '.12'], ['5px', '.18'], ['0px', '.24']];

  function box(kind, spec) {
    return '<svg class="cm-box cm-box--' + kind + '" style="--x:' + spec[0] + ';--d:' + spec[1] + '" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<rect class="b" x="1" y="2" width="14" height="13" rx="3"/><rect class="t" x="6.5" y="2" width="3" height="13"/></svg>';
  }
  function html(str) {
    var t = document.createElement('template');
    t.innerHTML = str;
    return t.content.firstElementChild;
  }

  function announce() {
    if (!live) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = 'Añadido al carrito'; }, 60);
  }

  /* Mide el botón para que el carrito y el camión recorran siempre su ancho real (móvil u ordenador) */
  function measure(btn, host) {
    var cart = btn.querySelector('.cm-cart');
    var w = btn.offsetWidth;
    host.style.setProperty('--cm-h', btn.offsetHeight + 'px');
    host.style.setProperty('--cm-to-centre', (w / 2 - (cart.offsetLeft + cart.offsetWidth / 2)) + 'px');
    host.style.setProperty('--cm-to-end', (w / 2 + 90) + 'px');
    host.style.setProperty('--cm-cx', (btn.offsetLeft + w / 2) + 'px');
    host.style.setProperty('--cm-top', btn.offsetTop + 'px');
  }

  function clearHold() {
    if (!hold) return;
    clearTimeout(hold.timer);
    hold.host.removeAttribute('data-cm');
    hold = null;
  }

  /* ok = true: terminó bien (se abre el carrito y el botón conserva «Añadido» un instante)
     ok = false: la compra falló (se corta el efecto) */
  function end(ok) {
    var a = active;
    if (!a) return;
    active = null;
    a.timers.forEach(clearTimeout);
    if (a.okBg && a.onEnd) a.okBg.removeEventListener('animationend', a.onEnd);
    if (a.restore) a.label.textContent = a.text;
    if (gate === a.g) gate = null;
    a.g.resolve();
    if (ok && !a.restore) {
      hold = { host: a.host, timer: setTimeout(function () { a.host.removeAttribute('data-cm'); hold = null; }, HOLD) };
    } else {
      a.host.removeAttribute('data-cm');
    }
  }

  function start(btn) {
    clearHold();
    var host = btn.parentElement;
    var label = btn.querySelector('.cm-label');
    var g = {};
    g.promise = new Promise(function (resolve) { g.resolve = resolve; });
    gate = g;
    active = { btn: btn, host: host, label: label, text: label.textContent, g: g, timers: [], restore: false };
    announce();

    if (reduce.matches) {
      /* Sin movimiento: el texto cambia un instante y se abre el carrito */
      active.restore = true;
      label.textContent = 'Añadido';
      active.timers.push(setTimeout(function () { end(true); }, 900));
      return;
    }

    measure(btn, host);
    host.setAttribute('data-cm', 'adding');
    active.okBg = btn.querySelector('.cm-bg--ok');
    active.onEnd = function (ev) { if (ev.animationName === 'cm-ok-bg') end(true); };
    active.okBg.addEventListener('animationend', active.onEnd);
    active.timers.push(setTimeout(function () { end(true); }, RUN + 400)); /* por si el navegador no avisa del final */
  }

  /* El tema abre el carrito en cuanto Shopify confirma la compra.
     Aquí se retiene esa apertura hasta que termina el movimiento. */
  function patchCart() {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || cart.__cm) return;
    var orig = cart.renderContents;
    if (typeof orig !== 'function') return;
    cart.__cm = true;
    cart.renderContents = function () {
      var self = this;
      var args = arguments;
      var g = gate;
      if (!g) return orig.apply(self, args);
      return g.promise.then(function () { return orig.apply(self, args); });
    };
  }

  /* Si la compra falla, no se muestra el efecto de éxito */
  function watchErrors() {
    if (subscribed || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribed = true;
    subscribe(PUB_SUB_EVENTS.cartError, function () { end(false); });
  }

  function onClick(e) {
    var btn = e.currentTarget;
    if (active || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    patchCart();
    watchErrors();
    start(btn);
  }

  function enhance(btn) {
    if (btn.classList.contains('cm-btn')) return;
    if (btn.closest('quick-add-modal') || !btn.closest('product-info')) return;
    var host = btn.parentElement;
    var label = btn.querySelector('span'); /* el primer span es el texto: el tema lo usa para cambiarlo */
    if (!host || !label) return;
    btn.classList.add('cm-btn');
    host.classList.add('cm-host');
    label.classList.add('cm-label');

    /* El tema oculta todo lo que va DETRÁS de la ruedecita de carga mientras se confirma la compra
       (.loading__spinner:not(.hidden) ~ *). Por eso todas las capas se colocan DELANTE de ella. */
    var spinner = btn.querySelector('.loading__spinner');
    var before = spinner && spinner.parentNode === btn ? spinner : null;
    function add(str) { btn.insertBefore(html(str), before); }
    add('<span class="cm-bg"></span>');
    add('<span class="cm-bg cm-bg--ok"></span>');
    add(CART);
    add('<span class="cm-clip">' + BOXES.map(function (b) { return box('in', b); }).join('') + '</span>');
    add(OK);
    add(TRUCK);
    BOXES.forEach(function (b) { host.insertBefore(html(box('out', b)), btn); });
    btn.addEventListener('click', onClick);
  }

  function scan() {
    var list = document.querySelectorAll('.product-form__submit');
    for (var i = 0; i < list.length; i++) enhance(list[i]);
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  scan();
  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
})();
